import getDefaultLocale from '~/utils/locale/getDefaultLocale'

export default (): string => {
  const { appUrl } = getDefaultLocale()

  return appUrl ?? ''
}
